import { hashQuery, omitPagination, stateList } from './utils'
import { merge, queryOnObject } from '../views/utils'
import modules from './modules'
import queryJoin from './queryJoin'

// stub getters for each module
const storeModulesWithAutoGetters = Object
  .values(modules)
  .filter(storeModule => storeModule.auto.has('getters'))

const queryShallow = state => queryOnObject(stateList(state), state)

storeModulesWithAutoGetters.forEach((storeModule) => {
  const { storeKey, storeSuffix } = storeModule

  merge(storeModule, {
    store: {
      getters: {
        [storeKey]: stateList,
        [`${storeKey}Suffix`]: state => state.storeSuffix,
      },
      state: {
        storeSuffix,
        pagination: {},
      },
    },
  })
})

const storeQueries = Object
  .fromEntries(storeModulesWithAutoGetters
    .map(storeModule => [storeModule.storeKey, {
      query: queryShallow,
      queryJoin: queryJoin(storeModule),
    }]))

const queryFactory = queryType => (state, getters) => (storeKey, params, options) =>
  storeQueries[storeKey][queryType](state[storeKey], getters)(params, options)

const getters = {
  getStoreModule: () => storeKey => modules
    .find(storeModule => storeModule.storeKey === storeKey),

  getPageObject: state => (storeKey, queryParams) => {
    return state[storeKey].pages[hashQuery(omitPagination(queryParams))]
  },

  getPageTotal: (_, { getPageObject }) => (storeKey, queryParams) => {
    return getPageObject(storeKey, queryParams)?.total
  },

  getQueryPage: (_, { getPageObject }) => (storeKey, queryParams, skip) => {
    return getPageObject(storeKey, queryParams)?.positions?.[skip]
  },

  ...Object
    .fromEntries(['query', 'queryJoin']
      .map(queryType => [queryType, queryFactory(queryType)])),
}

export default getters
